




















































































import { Component, Vue } from "vue-property-decorator";
import { userPagePomment } from "@/req/user";
import starRate from "@/components/starRate.vue";
@Component({ components: { starRate } })
export default class Logout extends Vue {
  public valueText = 2.5;
  public list: any = [];
  public mounted() {
    /* if (!this.$fn.cookies.getToken()) {
      return false;
    } */
    this.getList();
  }
  // 获取列表
  public async getList() {
    const res = await userPagePomment({ token: this.$fn.cookies.getToken() });
    if (res.code == 200) {
      this.list = res.data.appraiseData.data;
      this.$emit("sendppraiseNum", res.data.total_num.num);
    }
  }
  public getPath() {
    this.$router.push("/home/newServer")
  }
}
